var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn"},[_c('v-server-table',{ref:"vouchersTable",attrs:{"url":_vm.apiurl('voucher/table/fu'),"columns":_vm.columns,"options":_vm.options,"theme":_vm.theme,"id":"vouchersTable"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }